"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncExternalSiteFilterState = exports.embedInternalSiteIdsState = exports.embedInternalFilterState = exports.selectedSiteIdsState = exports.siteTreeFlatListState = exports.siteTreeState = exports.internalSelectedSiteNodesState = exports.hasEmbeddedSiteFiltersState = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@alcumus/components");
const recoil_1 = require("recoil");
const EmbedSiteTreeProvider_1 = require("../../../providers/EmbedSiteTreeProvider");
const CopyDashboardModal_1 = __importDefault(require("../Modals/CopyDashboardModal"));
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const EmbedReport_1 = __importDefault(require("./EmbedReport"));
const useQuery_1 = require("../../../lib/utils/useQuery");
const PanelSection_1 = __importDefault(require("../shared/PanelSection"));
const NavBar_1 = __importDefault(require("../NavBar"));
const EmbedSiteTree_1 = __importDefault(require("../SiteTree/EmbedSiteTree"));
const antd_1 = require("antd");
const CopyDashboardButton_1 = __importDefault(require("../Button/CopyDashboardButton"));
exports.hasEmbeddedSiteFiltersState = (0, recoil_1.atom)({
    key: 'hasEmbeddedSiteFiltersState',
    default: false,
});
exports.internalSelectedSiteNodesState = (0, recoil_1.atom)({
    key: 'internalSelectedSiteNodesState',
    default: undefined,
});
exports.siteTreeState = (0, recoil_1.atom)({
    key: 'siteTreeState',
    default: [],
});
exports.siteTreeFlatListState = (0, recoil_1.atom)({
    key: 'siteTreeFlatListState',
    default: undefined,
});
exports.selectedSiteIdsState = (0, recoil_1.atom)({
    key: 'selectedSiteIdsState',
    default: undefined,
});
exports.embedInternalFilterState = (0, recoil_1.atom)({
    key: 'embedInternalFilterState',
    default: {},
});
exports.embedInternalSiteIdsState = (0, recoil_1.atom)({
    key: 'embedInternalSiteIdsState',
    default: undefined,
});
exports.syncExternalSiteFilterState = (0, recoil_1.atom)({
    key: 'syncExternalSiteFilterState',
    default: false,
});
const EmbedReportPage = ({ match }) => {
    const [treeData, setSiteTreeData] = (0, recoil_1.useRecoilState)(exports.siteTreeState);
    const [siteTreeFlatList, setSiteTreeFlatList] = (0, recoil_1.useRecoilState)(exports.siteTreeFlatListState);
    const [hasSiteFilters, setHasEmbeddedSiteFilters] = (0, recoil_1.useRecoilState)(exports.hasEmbeddedSiteFiltersState);
    const embeddedSitesFilterElementRef = (0, react_1.useRef)(null);
    const [, setInternalSelectedSiteNodes] = (0, recoil_1.useRecoilState)(exports.internalSelectedSiteNodesState);
    const [, setEmbedInternalFilter] = (0, recoil_1.useRecoilState)(exports.embedInternalFilterState);
    const [, setEmbedInternalSiteIds] = (0, recoil_1.useRecoilState)(exports.embedInternalSiteIdsState);
    const [, i18n] = (0, react_i18next_1.useTranslation)();
    const folderId = Number(match.params.folderId);
    const lookId = (0, useQuery_1.useQuery)().get('lookId');
    const dashboardId = (0, useQuery_1.useQuery)().get('dashboardId');
    const viewType = lookId
        ? reportElementTypes_1.ReportElementTypes.Look
        : reportElementTypes_1.ReportElementTypes.Dashboard;
    const mapSelectedSiteNodes = (0, react_1.useCallback)((selectedInternalSiteIds) => {
        if (!selectedInternalSiteIds || !treeData.length)
            return;
        const selectedNodes = siteTreeFlatList
            ?.filter((site) => selectedInternalSiteIds.filter((int) => int === site.id).length > 0)
            .map((site) => ({ value: site.id, label: site.name }));
        setInternalSelectedSiteNodes(selectedNodes);
    }, [setInternalSelectedSiteNodes, treeData]);
    const handleEmbeddedSiteFiltersChange = (0, react_1.useCallback)((mutation) => {
        const target = mutation.target;
        const value = target.getAttribute('value');
        if (value) {
            const filters = JSON.parse(value);
            setEmbedInternalFilter(filters);
            const siteFilterKey = Object.keys(filters).find((key) => key.toLowerCase() === 'site');
            if (!siteFilterKey) {
                return;
            }
            const siteFilters = filters[siteFilterKey]?.split(',');
            setEmbedInternalSiteIds(siteFilters);
            mapSelectedSiteNodes(siteFilters);
        }
    }, [mapSelectedSiteNodes]);
    (0, react_1.useEffect)(() => {
        // TODO enable calls to getSiteFilterFor and mutationObserver
        // when site tree is implemented
    }, [handleEmbeddedSiteFiltersChange, setHasEmbeddedSiteFilters]);
    const getSiteTreeData = (0, react_1.useCallback)(() => {
        if (hasSiteFilters)
            (0, EmbedSiteTreeProvider_1.embedSiteTreeProvider)({}).then((res) => {
                setSiteTreeFlatList(res.siteFlatList);
                return setSiteTreeData(res.siteTree);
            });
    }, [hasSiteFilters]);
    (0, react_1.useEffect)(() => {
        getSiteTreeData();
        return () => {
            setInternalSelectedSiteNodes(undefined);
            setSiteTreeData([]);
        };
    }, [getSiteTreeData]);
    return (react_1.default.createElement(components_1.TranslateReady, { tReady: i18n.isInitialized },
        react_1.default.createElement(NavBar_1.default, null,
            react_1.default.createElement(PanelSection_1.default, { footer: !!treeData.length && (react_1.default.createElement(antd_1.Row, null,
                    react_1.default.createElement(antd_1.Col, { span: 4 }),
                    react_1.default.createElement(antd_1.Col, { span: 16 },
                        react_1.default.createElement(EmbedSiteTree_1.default, null)),
                    react_1.default.createElement(antd_1.Col, { span: 4 }))), enableGoBack: true, panelSettings: viewType === reportElementTypes_1.ReportElementTypes.Dashboard &&
                    localStorage.getItem('user_is_editor') === 'true' && (react_1.default.createElement(CopyDashboardButton_1.default, null)) },
                react_1.default.createElement("input", { ref: embeddedSitesFilterElementRef, id: "embeddedSitesFilters", type: "hidden" }),
                react_1.default.createElement(EmbedReport_1.default, { embedReportId: lookId ?? dashboardId, embedReportType: viewType }),
                react_1.default.createElement(CopyDashboardModal_1.default, { dashboardId: dashboardId, defaultFolderId: folderId })))));
};
exports.default = EmbedReportPage;
